import React from "react";
import moment from "moment";
import { useSmartNavigate } from '@/hooks/use-smart-navigate';

export const Equipment_CategoryProps = {
    title: 'Facility Category',
    description: '',
    name: 'equipmentCategory',
}

const GotoDetail = ({ id, label }) => {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const handleClick = (e) => {
        e.stopPropagation();
        navigateAndCloseTabs(`/admin/equipment-category-detail/${id}`, '/admin/equipment-category-detail/');
    };
    return label
        ? <a onClick={handleClick}>{label}</a>
        : <a onClick={handleClick}><i className="fas fa-expand-arrows-alt text-lg"></i></a>;
}

export const Equipment_CategoryColumns = [
    {
        title: 'key',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        width: '4%',
        hideInTable: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        search: false,
        editable: false,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        formItemProps: {
            rules: [
                {
                    required: true,
                    message: 'required',
                },
            ],
        },
        render: (text, record) => (
            <GotoDetail id={record.id} label={text} />
        )
    },
    {
        title: 'Life Expectancy (Years)',
        dataIndex: 'life_expectancy',
        key: 'life_expectancy',
        editable: false,
        hideInTable: window.innerWidth < 760,
        width: 150,
        align: 'right', // 数字列右对齐
        sorter: (a, b) => (a.life_expectancy || 0) - (b.life_expectancy || 0),
        formItemProps: {
            rules: [
                {
                    pattern: /^[0-9]\d*$/,
                    message: 'Must be a positive integer',
                },
            ],
        },
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        hideInTable: window.innerWidth < 760,
        editable: false
    },
    {
        title: 'Modified Date',
        dataIndex: 'modified_date',
        key: 'modified_date',
        editable: false,
        importIngore: true,
        hideInTable: window.innerWidth < 760,
        width: 150,
        align: 'right',
        sorter: (a, b) => new Date(a.modified_date || 0) - new Date(b.modified_date || 0),
        render: (value) => {
            const date = moment(value);
            return value && date.isValid() ? date.format('YYYY-MM-DD HH:mm') : '-';
        },
    },
    // {
    //     title: '',
    //     valueType: 'option',
    //     width: '6rem',
    //     importIngore: true,
    //     render: (text, record, _, action) => (
    //         <div className={'space-around'}>
    //             <a
    //                 key="editable"
    //                 onClick={() => (action?.startEditable?.(record.id))}
    //             >
    //                 <i className="fas fa-edit text-lg"></i>
    //             </a>
    //             <GotoDetail id={record.id} />
    //         </div>
    //     ),
    // },
];
